import { Jwt } from '@thingslog/repositories';
import JwtValidator from './JwtValidator';

export default class RedirectHelper {
  private jwtValidator: JwtValidator;

  public constructor(user?: Jwt | null) {
    this.jwtValidator = new JwtValidator(user);
  }

  // #region public methods
  public shouldRedirectToManagement = (): boolean => {
    const decodedToken = this.jwtValidator.decodedToken;
    if (decodedToken) {
      if (this.jwtValidator.hasCompanySelectionRole() && this.hasSelectedCompanyId()) {
        return false;
      }

      return decodedToken.isDashboardEnabled ? false : true;
    }
    return true;
  };

  public redirectToManagement = (): void => {
    window.location.href = `${location.protocol}//${location.host}/app`;
  };
  // #endregion

  private hasSelectedCompanyId = (): boolean => {
    const selectedCompanyRaw = localStorage.getItem('selectedCompany');

    if (!selectedCompanyRaw) {
      return false;
    }

    try {
      const selectedCompany = JSON.parse(selectedCompanyRaw) as { id?: unknown };
      if (
        selectedCompany.id === undefined ||
        selectedCompany.id === null ||
        selectedCompany.id === ''
      ) {
        return false;
      }

      const selectedCompanyId = Number(selectedCompany.id);

      return Number.isFinite(selectedCompanyId);
    } catch {
      return false;
    }
  };
}
